import moment from 'moment';

const useChartCategories = ({ chartData }) => {
  const xAxisDateFormat = 'MMM D';
  const xAxisCategories =
    chartData.map(item => moment(item.week).format(xAxisDateFormat)) || [];

  return xAxisCategories;
};

export default useChartCategories;
